module.exports = __webpack_public_path__ + "static/media/scarlett.f7dd4747.jpg";